import React, { useLayoutEffect, useRef, useState } from 'react'
import { AlertStyled } from './styles'

const Alert = ({ isOpen, alertFor, children }) => {

  const alertRef = useRef()

  if (!isOpen) return null

  return (
    <AlertStyled ref={alertRef}>
      {children}
    </AlertStyled>
  )
}

export default Alert